import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function UnitedKingdomJurisdiction() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.united-kingdom-jurisdiction.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/united-kingdom-jurisdiction"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/uk-jurisdiction.png')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title={tp('why.title')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <InfoBlocks
                        title={tp('company.title')}
                        blocks={obj('company.blocks')}
                    />

                    <InfoBlocks
                        title={tp('licenses.title')}
                        blocks={obj('licenses.blocks')}
                    />

                    <LocationTimeline
                        title={tp('process.title')}
                        item={obj('process.items')}
                    />

                    <ServiceCards
                        title={tp('advantages.title')}
                        services={obj('advantages.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};
